<template>
  <div class="paintings-slider-container" ref="paintingSliderContainer">
    <div :class="['painting-slider-top', { active: !getDetailActive }]">
      <!-- @click="closeTab" -->
      <PaintingsSlider :paintingSliderGoTo="paintingSliderGoTo" />
      <div class="paint-meta">
        <img
          class="arrow-left"
          v-if="getDetailActive && getPaint.index > 0"
          @click="paintingSliderGoTo = getPaint.index - 1"
          :src="
            `${baseUrl}assets/images/atoms-icons-actions-navigation-chevron-left.svg`
          "
          alt="arrow left"
        />
        <div class="paint-meta-wrapper">
          <div class="paint-title">
            {{ getPaint.title }}
          </div>
          <div class="paint-tech-link">
            <div class="paint-tech">{{ getPaint.tech }}</div>
            <a
              :class="['paint-link', { disabled: getPaint.link.length < 5 }]"
              :href="getPaint.link"
              target="_blank"
            >
              <!-- {{
            getPaint.linkType.toLowerCase() === "venue"
              ? getPaint.museum + ", "
              : ""
          }}{{ getPaint.city }} -->
              {{ getPaint.museum ? getPaint.museum + ", " : ""
              }}{{ getPaint.city }}
              <img
                :src="
                  `${baseUrl}assets/images/atoms-icons-actions-navigation-link.svg`
                "
                alt="external link"
              />
            </a>
          </div>
        </div>
        <img
          class="arrow-right"
          v-if="
            getDetailActive &&
              getPaint.index < $ml.get('data')[$ml.get('data').length - 1].index
          "
          @click="paintingSliderGoTo = getPaint.index + 1"
          :src="
            `${baseUrl}assets/images/atoms-icons-actions-navigation-chevron-right.svg`
          "
          alt="arrow right"
        />
      </div>
    </div>
    <div :class="['painting-slider-bottom', { active: getDetailActive }]">
      <div class="button-primary-container">
        <button class="button-primary" @click="toggleDetailActive">
          <template v-if="!getDetailActive">
            {{ $ml.get("content").button_gallery }}
          </template>
          <template v-else>
            <img
              :src="
                `${baseUrl}assets/images/atoms-icons-actions-navigation-close.svg`
              "
              alt="close"
            />
          </template>
        </button>
      </div>
      <PaintDetail v-if="getDetailActive" />
    </div>

    <div
      class="bg-image"
      :style="{
        backgroundImage: `url('${baseUrl}assets/paintings/${
          $tvaMq === 'desktop' || $tvaMq === 'tablet'
            ? '500'
            : $tvaMq === 'large'
            ? '800'
            : '300'
        }/${getPaint.id}-0.jpg')`,
        backgroundPosition: getDetailActive ? '50% 60%' : '50% 40%'
      }"
    ></div>
  </div>
</template>

<script>
import PaintingsSlider from "@/components/PaintingsSlider.vue";
import PaintDetail from "@/components/PaintDetail.vue";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "paintings-slider-container",
  data() {
    return {
      paintingSliderGoTo: null,
      baseUrl: process.env.BASE_URL
    };
  },
  created() {
    this.setDetailActive(false);
  },
  computed: {
    ...mapGetters(["getPaint", "getDetailActive"])
  },
  methods: {
    closeTab(e) {
      if (
        this.$refs.paintingSliderContainer &&
        e.target.tagName.toLowerCase() !== "button" &&
        e.target.tagName.toLowerCase() !== "a" &&
        e.target.tagName.toLowerCase() !== "img"
      ) {
        this.setPaint(null);
        this.setMuseum(null);
        this.setDetailActive(null);
      }
    },
    ...mapActions([
      "toggleDetailActive",
      "setDetailActive",
      "setPaint",
      "setMuseum"
    ])
  },
  components: {
    PaintingsSlider,
    PaintDetail
  }
};
</script>

<style lang="scss" scoped>
.paintings-slider-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: darken(rgb(249, 227, 190), 80%);
  animation: fadeIn 0.4s ease-out;
  animation-fill-mode: forwards;
  opacity: 0;
  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
  .painting-slider-top {
    margin-top: calc(-70vh + 120px);
    height: calc(100% - 110px);
    transition: margin 0.7s ease;
    @media (min-aspect-ratio: 16/9) {
      margin-top: calc(-80vh + 120px);
    }
    @media (max-width: 720px) {
      margin-top: calc(-78vh + 120px);
    }
    .paint-meta {
      display: flex;
      justify-content: center;
      @media (max-width: 720px) {
        padding: 0 5px;
      }
      .arrow-left {
        cursor: pointer;
        margin-right: 15px;
      }
      .arrow-right {
        cursor: pointer;
        margin-left: 15px;
      }
      .paint-meta-wrapper {
        display: flex;
        flex-direction: column;
        align-items: center;
        min-width: 30%;

        .paint-title {
          margin-bottom: 7px;
          @include button-large;
        }
        .paint-tech-link {
          display: flex;

          .paint-tech {
            @include dida-big-desktop;
            padding-right: 8.5px;
            margin-right: 9.5px;
            border-right: solid 1px $white;
          }
          .paint-link {
            @include link-big-desktop;
            img {
              width: 15px;
              transform: translate(2px, 2px);
            }
            &:hover {
              text-decoration: underline !important;
            }
            &.disabled {
              text-decoration: none;
              pointer-events: none;
              img {
                display: none;
              }
            }
          }
          @media (max-width: 720px) {
            flex-direction: column;
            .paint-tech {
              margin: 0;
              border: none;
            }
          }
        }
      }
      @media (max-width: 720px) {
        .paint-meta-wrapper {
          width: calc(100% - 120px);
        }
      }
    }
    &.active {
      margin-top: 0;
    }
  }
  .painting-slider-bottom {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    height: 70vh;
    padding: 10px 0 40px 0;
    box-shadow: 0 -6px 30px 0 rgba(0, 0, 0, 0.2);
    background: linear-gradient(
      to bottom,
      rgba(0, 0, 0, 0) 11%,
      rgba(0, 0, 0, 0.8) 89%
    );
    @media (min-aspect-ratio: 16/9) {
      height: 80vh;
    }
    @media (max-width: 720px) {
      height: 78vh;
      justify-content: flex-start;
      padding-top: 30px;
    }
    .button-primary-container {
      position: absolute;
      top: -17.5px;
      width: 100%;
      left: 0;
      display: flex;
      justify-content: center;
      .button-primary {
      }
    }
    &.active {
      .button-primary-container {
        .button-primary {
          width: 35px;
          padding: 0;
          height: 35px;
          display: flex;
          justify-content: center;
          align-items: center;
          img {
            display: block;
            pointer-events: none;
          }
        }
      }
    }
  }

  .bg-image {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: -1;
    background-size: cover;
    filter: blur(40px) grayscale(30%) opacity(60%);
    transition: background 0.5s ease 0.2s;
    // &::after {
    //   content: "";
    //   position: absolute;
    //   top: 0;
    //   left: 0;
    //   width: 100%;
    //   height: 100%;
    //   backdrop-filter: blur(30px);
    //   background: rgba(#000, 0.6);
    // }
  }
}
</style>
